import * as yup from 'yup';
import { Row, RenderConfig, SelectInput, TextInput, BOOLEAN_OPTIONS, AsyncSelect } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	descriptionHi: 'descriptionHi',
	descriptionEn: 'descriptionEn',
	category: 'category',
	isActive: 'isActive'
};

export const validationSchema = yup.object().shape({
	en: yup.string().required('Description is a required field'),
	hi: yup.string().required('Description is a required field'),
	category: yup.string().required('Category Type is a required field'),
	isActive: yup.boolean().required('IsActive is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.descriptionEn]: new RenderConfig()
		.setName('en')
		.setLabel('Description (English)')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true, view: true }, required: true, inputType: 'string' }),
	[FORM_FIELD_KEYS.descriptionHi]: new RenderConfig()
		.setName('hi')
		.setLabel('Description (Hindi)')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true, view: true }, required: true, inputType: 'string' }),
	[FORM_FIELD_KEYS.category]: new RenderConfig()
		.setName('category')
		.setLabel('Category')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.isActive]: new RenderConfig()
		.setName('isActive')
		.setLabel('IsActive')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, options: BOOLEAN_OPTIONS })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.descriptionEn),
	new Row(FORM_FIELD_KEYS.descriptionHi),
	new Row(FORM_FIELD_KEYS.category),
	new Row(FORM_FIELD_KEYS.isActive)
];
